import React from 'react';
import Login from '../components/UI/login/Login';

const LoginPage: React.FC = () => {

  return (
    <div className='login w-screen h-screen overflow-hidden flex justify-center items-center p-5'>
      <Login />
    </div>
  );
};

export default LoginPage;
